import { SiteContent } from '../content';

type ContactContent = SiteContent['contact'];

interface ContactSectionProps {
  content: ContactContent;
}

export default function ContactSection({ content }: ContactSectionProps) {
  // Filter out empty emails
  const activeEmails = content.emails.filter(email => email && email.trim() !== '');

  return (
    <section id="contact" className="section-dark py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-semibold mb-6">
            {content.title}
          </h2>
          <p className="text-lg md:text-xl text-milan-gray-light leading-relaxed max-w-2xl mx-auto mb-12">
            {content.description}
          </p>

          {/* Contact Info */}
          <div className="space-y-8">
            {/* Email Addresses */}
            {activeEmails.length > 0 && (
              <div className="space-y-4">
                <h3 className="text-sm uppercase tracking-wider text-milan-gray mb-4">
                  Email Us
                </h3>
                <div className="flex flex-col items-center gap-3">
                  {activeEmails.map((email, index) => (
                    <a
                      key={index}
                      href={`mailto:${email}`}
                      className="flex items-center text-lg text-white/90 hover:text-white transition-colors"
                    >
                      <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                      {email}
                    </a>
                  ))}
                </div>
              </div>
            )}

            {/* Phone */}
            {content.phone && (
              <div className="space-y-4">
                <h3 className="text-sm uppercase tracking-wider text-milan-gray mb-4">
                  Call Us
                </h3>
                <a
                  href={`tel:${content.phone.replace(/[^0-9]/g, '')}`}
                  className="inline-flex items-center text-lg text-white/90 hover:text-white transition-colors"
                >
                  <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  {content.phone}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
